module.exports = require("react-table");